const guideLink = {
  avatar: 'https://cube.meituan.com/cube/block/0bb53118604980e4bacc/211530/index.html',
  oneBuy: 'https://cube.meituan.com/cube/block/8ed522df09e7e79944e9/211531/index.html',
  envelope: 'https://cube.meituan.com/cube/block/24f20936a6a010f834c0/211532/index.html',
  hardWallet: 'https://cube.meituan.com/cube/block/94a91187cc0c58a511d9/211533/index.html',
  coupon: 'https://cube.meituan.com/cube/block/d6bc9df2a0458ac373d2/212933/index.html'
};

export {
  guideLink
};
